import React from 'react';

interface NoItemsFoundProps {
  message?: string;
}

const NoItemsFound: React.FC<NoItemsFoundProps> = ({ message = 'No Items Found' }) => {
  return (
    <div className="flex h-[20rem] justify-center items-center">
      <h1 className="text-storyblue font-bold mt-[5rem]">{message}</h1>
    </div>
  );
};

export default NoItemsFound;
